/**
 * Notamicro Frontend Application
 *
 * Main entry point. Initializes Stimulus.js and loads all controllers.
 */

import { Application } from "/js/vendor/stimulus.js";

// Initialize Stimulus Application
window.Stimulus = Application.start();

// Configure Stimulus development experience
Stimulus.debug = false;

console.log("Notamicro Frontend Application initialized");
